<script setup>
</script>

<template>
    <div>
        <h2>③ Dance</h2>

        <NPCDance/>
    </div>
</template>
